import { render, staticRenderFns } from "./CatPerfReport.vue?vue&type=template&id=1abf3268&"
import script from "./CatPerfReport.vue?vue&type=script&lang=js&"
export * from "./CatPerfReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports